import { lineEnum } from './constant';

export const getLiveStreamInfoById = (id: string) => {
  const protocol = {
    ali: 'https://',
    bd: 'https://'
  };
  const base_url = {
    ali: 'kevideopullaly.ydstatic.com',
    bd_flv: 'kevideopullbd.ydstatic.com',
    bd_hls: 'kevideohpullbd.ydstatic.com'
  };
  const stream_list: { [key: string]: string } = {
    1: '5b1d07e647bf_screen',
    2: 'fda361333592_screen',
    3: '244336e152a3_screen',
    4: '5a7cedffc94d_screen',
    5: '7c734e5efa1b_screen',
    6: '7a882084b2b7_screen',
    7: 'd98264ae8256_screen',
    8: 'fd6d511c3f88_screen',
    9: 'b0ed27126048_screen',
    10: 'bfd4621721b0_screen',
    11: 'c6c325049ea0_screen',
    12: '2dbae0df89a0_screen',
    13: 'd5b9bf85455d_screen',
    14: 'c18a5d949656_screen',
    // youdao test stream
    t1: 'ydtest1_screen',
    t2: 'ydtest2_screen',
    t3: 'ydtest3_screen',
    t4: 'ydtest4_screen',
    t5: 'ydtest5_screen'
  };

  const stream_name = stream_list[id];

  // default line: 1- ali
  const line1 = {
    hls: [
      {
        definition: '原画',
        url: `${protocol.ali}${base_url.ali}/pushstation/${stream_name}_ud.m3u8`,
        text: {
          zh: '原画',
          en: '1080P'
        }
      },
      {
        definition: '高清',
        url: `${protocol.ali}${base_url.ali}/pushstation/${stream_name}_hd.m3u8`,
        text: {
          zh: '高清',
          en: 'HD'
        }
      },
      {
        definition: '标清',
        url: `${protocol.ali}${base_url.ali}/pushstation/${stream_name}_sd.m3u8`,
        text: {
          zh: '标清',
          en: 'SD'
        }
      }
    ],
    flv: [
      {
        definition: '原画',
        url: `${protocol.ali}${base_url.ali}/pushstation/${stream_name}_ud.flv`,
        text: {
          zh: '原画',
          en: '1080P'
        }
      },
      {
        definition: '高清',
        url: `${protocol.ali}${base_url.ali}/pushstation/${stream_name}_hd.flv`,
        text: {
          zh: '高清',
          en: 'HD'
        }
      },
      {
        definition: '标清',
        url: `${protocol.ali}${base_url.ali}/pushstation/${stream_name}_sd.flv`,
        text: {
          zh: '标清',
          en: 'SD'
        }
      }
    ]
  };
  // line 2 - bd
  const line2 = {
    hls: [
      {
        definition: '原画',
        url: `${protocol.bd}${base_url.bd_hls}/pushstation/${stream_name}.m3u8`,
        text: {
          zh: '原画',
          en: '1080P'
        }
      },
      {
        definition: '高清',
        url: `${protocol.bd}${base_url.bd_hls}/pushstation/${stream_name}-L1.m3u8`,
        text: {
          zh: '高清',
          en: 'HD'
        }
      },
      {
        definition: '标清',
        url: `${protocol.bd}${base_url.bd_hls}/pushstation/${stream_name}-L2.m3u8`,
        text: {
          zh: '标清',
          en: 'SD'
        }
      }
    ],
    flv: [
      {
        definition: '原画',
        url: `${protocol.bd}${base_url.bd_flv}/pushstation/${stream_name}.flv`,
        text: {
          zh: '原画',
          en: '1080P'
        }
      },
      {
        definition: '高清',
        url: `${protocol.bd}${base_url.bd_flv}/pushstation/${stream_name}-L1.flv`,
        text: {
          zh: '高清',
          en: 'HD'
        }
      },
      {
        definition: '标清',
        url: `${protocol.bd}${base_url.bd_flv}/pushstation/${stream_name}-L2.flv`,
        text: {
          zh: '标清',
          en: 'SD'
        }
      }
    ]
  };
  const stream_info = {
    [lineEnum.line1]: line1,
    [lineEnum.line2]: line2
  };

  return stream_info;
};
